import React, { useState } from 'react';
import Modal from '../../../shared/components/ui/Modal';
import Button from '../../../shared/components/ui/Button';
import FormInput from '../../../shared/components/ui/FormInput';
import { formatISO } from 'date-fns';
import toast from 'react-hot-toast';
import { RiCloseLine } from 'react-icons/ri';

// List of major Indian banks
const INDIAN_BANKS = [
  // Public Sector Banks
  { id: 'State Bank of India', value: 'State Bank of India', label: 'State Bank of India' },
  { id: 'Punjab National Bank', value: 'Punjab National Bank', label: 'Punjab National Bank' },
  { id: 'Bank of Baroda', value: 'Bank of Baroda', label: 'Bank of Baroda' },
  { id: 'Canara Bank', value: 'Canara Bank', label: 'Canara Bank' },
  { id: 'Union Bank of India', value: 'Union Bank of India', label: 'Union Bank of India' },
  { id: 'Bank of India', value: 'Bank of India', label: 'Bank of India' },
  { id: 'Central Bank of India', value: 'Central Bank of India', label: 'Central Bank of India' },
  { id: 'Indian Bank', value: 'Indian Bank', label: 'Indian Bank' },
  { id: 'Indian Overseas Bank', value: 'Indian Overseas Bank', label: 'Indian Overseas Bank' },
  { id: 'UCO Bank', value: 'UCO Bank', label: 'UCO Bank' },
  { id: 'Bank of Maharashtra', value: 'Bank of Maharashtra', label: 'Bank of Maharashtra' },
  { id: 'Punjab & Sind Bank', value: 'Punjab & Sind Bank', label: 'Punjab & Sind Bank' },

  // Private Sector Banks - Large
  { id: 'HDFC Bank', value: 'HDFC Bank', label: 'HDFC Bank' },
  { id: 'ICICI Bank', value: 'ICICI Bank', label: 'ICICI Bank' },
  { id: 'Axis Bank', value: 'Axis Bank', label: 'Axis Bank' },
  { id: 'Kotak Mahindra Bank', value: 'Kotak Mahindra Bank', label: 'Kotak Mahindra Bank' },
  { id: 'IndusInd Bank', value: 'IndusInd Bank', label: 'IndusInd Bank' },
  { id: 'Yes Bank', value: 'Yes Bank', label: 'Yes Bank' },
  { id: 'IDFC First Bank', value: 'IDFC First Bank', label: 'IDFC First Bank' },
  { id: 'Federal Bank', value: 'Federal Bank', label: 'Federal Bank' },
  { id: 'RBL Bank', value: 'RBL Bank', label: 'RBL Bank' },
  { id: 'South Indian Bank', value: 'South Indian Bank', label: 'South Indian Bank' },
  { id: 'Karnataka Bank', value: 'Karnataka Bank', label: 'Karnataka Bank' },
  { id: 'City Union Bank', value: 'City Union Bank', label: 'City Union Bank' },
  { id: 'DCB Bank', value: 'DCB Bank', label: 'DCB Bank' },
  { id: 'Jammu & Kashmir Bank', value: 'Jammu & Kashmir Bank', label: 'Jammu & Kashmir Bank' },
  { id: 'IDBI Bank', value: 'IDBI Bank', label: 'IDBI Bank' },
  { id: 'Bandhan Bank', value: 'Bandhan Bank', label: 'Bandhan Bank' },
  { id: 'Karur Vysya Bank', value: 'Karur Vysya Bank', label: 'Karur Vysya Bank' },
  {
    id: 'Tamilnad Mercantile Bank',
    value: 'Tamilnad Mercantile Bank',
    label: 'Tamilnad Mercantile Bank'
  },
  { id: 'Nainital Bank', value: 'Nainital Bank', label: 'Nainital Bank' },
  { id: 'Catholic Syrian Bank', value: 'Catholic Syrian Bank', label: 'Catholic Syrian Bank' },
  { id: 'Dhanlaxmi Bank', value: 'Dhanlaxmi Bank', label: 'Dhanlaxmi Bank' },

  // Small Finance Banks
  { id: 'AU Small Finance Bank', value: 'AU Small Finance Bank', label: 'AU Small Finance Bank' },
  {
    id: 'Equitas Small Finance Bank',
    value: 'Equitas Small Finance Bank',
    label: 'Equitas Small Finance Bank'
  },
  {
    id: 'Ujjivan Small Finance Bank',
    value: 'Ujjivan Small Finance Bank',
    label: 'Ujjivan Small Finance Bank'
  },
  {
    id: 'Suryoday Small Finance Bank',
    value: 'Suryoday Small Finance Bank',
    label: 'Suryoday Small Finance Bank'
  },
  {
    id: 'Jana Small Finance Bank',
    value: 'Jana Small Finance Bank',
    label: 'Jana Small Finance Bank'
  },
  {
    id: 'Fincare Small Finance Bank',
    value: 'Fincare Small Finance Bank',
    label: 'Fincare Small Finance Bank'
  },
  {
    id: 'North East Small Finance Bank',
    value: 'North East Small Finance Bank',
    label: 'North East Small Finance Bank'
  },
  {
    id: 'Capital Small Finance Bank',
    value: 'Capital Small Finance Bank',
    label: 'Capital Small Finance Bank'
  },
  {
    id: 'ESAF Small Finance Bank',
    value: 'ESAF Small Finance Bank',
    label: 'ESAF Small Finance Bank'
  },
  {
    id: 'Utkarsh Small Finance Bank',
    value: 'Utkarsh Small Finance Bank',
    label: 'Utkarsh Small Finance Bank'
  },
  {
    id: 'Shivalik Small Finance Bank',
    value: 'Shivalik Small Finance Bank',
    label: 'Shivalik Small Finance Bank'
  },
  {
    id: 'Unity Small Finance Bank',
    value: 'Unity Small Finance Bank',
    label: 'Unity Small Finance Bank'
  },

  // Payment Banks
  { id: 'Paytm Payments Bank', value: 'Paytm Payments Bank', label: 'Paytm Payments Bank' },
  {
    id: 'India Post Payments Bank',
    value: 'India Post Payments Bank',
    label: 'India Post Payments Bank'
  },
  { id: 'Airtel Payments Bank', value: 'Airtel Payments Bank', label: 'Airtel Payments Bank' },
  { id: 'Fino Payments Bank', value: 'Fino Payments Bank', label: 'Fino Payments Bank' },
  { id: 'Jio Payments Bank', value: 'Jio Payments Bank', label: 'Jio Payments Bank' },
  { id: 'NSDL Payments Bank', value: 'NSDL Payments Bank', label: 'NSDL Payments Bank' },

  // Foreign Banks
  { id: 'Citibank', value: 'Citibank', label: 'Citibank' },
  { id: 'HSBC Bank', value: 'HSBC Bank', label: 'HSBC Bank' },
  {
    id: 'Standard Chartered Bank',
    value: 'Standard Chartered Bank',
    label: 'Standard Chartered Bank'
  },
  { id: 'Deutsche Bank', value: 'Deutsche Bank', label: 'Deutsche Bank' },
  { id: 'Barclays Bank', value: 'Barclays Bank', label: 'Barclays Bank' },
  {
    id: 'American Express Banking Corp',
    value: 'American Express Banking Corp',
    label: 'American Express Banking Corp'
  },
  { id: 'DBS Bank India', value: 'DBS Bank India', label: 'DBS Bank India' },
  { id: 'Bank of America', value: 'Bank of America', label: 'Bank of America' },
  { id: 'JPMorgan Chase Bank', value: 'JPMorgan Chase Bank', label: 'JPMorgan Chase Bank' },
  { id: 'BNP Paribas', value: 'BNP Paribas', label: 'BNP Paribas' },
  { id: 'Mizuho Bank', value: 'Mizuho Bank', label: 'Mizuho Bank' },
  {
    id: 'Sumitomo Mitsui Banking Corporation',
    value: 'Sumitomo Mitsui Banking Corporation',
    label: 'Sumitomo Mitsui Banking Corporation'
  },
  { id: 'Bank of China', value: 'Bank of China', label: 'Bank of China' },
  {
    id: 'Credit Agricole Corporate and Investment Bank',
    value: 'Credit Agricole Corporate and Investment Bank',
    label: 'Credit Agricole Corporate and Investment Bank'
  },
  { id: 'FirstRand Bank', value: 'FirstRand Bank', label: 'FirstRand Bank' },
  { id: 'Societe Generale', value: 'Societe Generale', label: 'Societe Generale' },
  {
    id: 'Royal Bank of Scotland',
    value: 'Royal Bank of Scotland',
    label: 'Royal Bank of Scotland'
  },
  { id: 'UBS AG', value: 'UBS AG', label: 'UBS AG' },
  { id: 'Credit Suisse', value: 'Credit Suisse', label: 'Credit Suisse' },
  {
    id: 'Industrial and Commercial Bank of China',
    value: 'Industrial and Commercial Bank of China',
    label: 'Industrial and Commercial Bank of China'
  },
  { id: 'Mashreq Bank', value: 'Mashreq Bank', label: 'Mashreq Bank' },
  { id: 'Doha Bank', value: 'Doha Bank', label: 'Doha Bank' },
  { id: 'Sberbank', value: 'Sberbank', label: 'Sberbank' },
  { id: 'Shinhan Bank', value: 'Shinhan Bank', label: 'Shinhan Bank' },
  { id: 'KEB Hana Bank', value: 'KEB Hana Bank', label: 'KEB Hana Bank' },
  { id: 'Woori Bank', value: 'Woori Bank', label: 'Woori Bank' },
  {
    id: 'China Construction Bank',
    value: 'China Construction Bank',
    label: 'China Construction Bank'
  },
  {
    id: 'Rabobank International',
    value: 'Rabobank International',
    label: 'Rabobank International'
  },
  {
    id: 'Australia and New Zealand Banking Group',
    value: 'Australia and New Zealand Banking Group',
    label: 'Australia and New Zealand Banking Group'
  },
  { id: 'Scotiabank', value: 'Scotiabank', label: 'Scotiabank' },
  {
    id: 'National Australia Bank',
    value: 'National Australia Bank',
    label: 'National Australia Bank'
  },
  {
    id: 'Westpac Banking Corporation',
    value: 'Westpac Banking Corporation',
    label: 'Westpac Banking Corporation'
  },
  {
    id: 'Commonwealth Bank of Australia',
    value: 'Commonwealth Bank of Australia',
    label: 'Commonwealth Bank of Australia'
  },
  { id: 'United Overseas Bank', value: 'United Overseas Bank', label: 'United Overseas Bank' },
  { id: 'CTBC Bank', value: 'CTBC Bank', label: 'CTBC Bank' },
  { id: 'MUFG Bank', value: 'MUFG Bank', label: 'MUFG Bank' },

  // Other
  { id: 'Other', value: 'Other', label: 'Other' }
].sort();

const AddChequeForm = ({
  isOpen,
  onClose,
  onSubmit,
  invoiceData,
  sanitizeToNumber,
  isSubmitting = false
}) => {
  const [cheques, setCheques] = useState([
    {
      amount: '',
      date: '',
      cheque_number: '',
      account_holder_name: '',
      bank_name: '',
      ifsc_code: ''
    }
  ]);
  const [applyAsPayment, setApplyAsPayment] = useState(true);

  // Dummy register function for FormInput components
  const dummyRegister = (fieldName) => ({
    onChange: () => {},
    onBlur: () => {},
    name: fieldName,
    ref: () => {}
  });

  // Cheque handling functions
  const handleChequeChange = (index, field, value) => {
    const newCheques = [...cheques];
    newCheques[index][field] = value;
    setCheques(newCheques);
  };

  const handleAddChequeRow = () => {
    setCheques([
      ...cheques,
      {
        amount: '',
        date: '',
        cheque_number: '',
        account_holder_name: '',
        bank_name: '',
        ifsc_code: ''
      }
    ]);
  };

  const handleRemoveChequeRow = (index) => {
    if (cheques.length > 1) {
      const newCheques = cheques.filter((_, i) => i !== index);
      setCheques(newCheques);
    }
  };

  // Reset cheques on modal close
  const resetChequeModal = () => {
    // Prevent closing if submitting
    if (isSubmitting) return;

    setCheques([
      {
        amount: '',
        date: '',
        cheque_number: '',
        account_holder_name: '',
        bank_name: '',
        ifsc_code: ''
      }
    ]);
    setApplyAsPayment(true);
    onClose();
  };

  // Validate IFSC code format (optional but if provided must be valid)
  const validateIFSC = (ifscCode) => {
    if (!ifscCode) return true; // Optional field
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    return ifscRegex.test(ifscCode);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Validate all cheques
    for (const cheque of cheques) {
      if (!cheque.amount || !cheque.date || !cheque.cheque_number || !cheque.account_holder_name) {
        toast.error('Please fill all required fields for all cheques.');
        return;
      }

      const amount = sanitizeToNumber(cheque.amount);
      if (!Number.isFinite(amount) || amount <= 0) {
        toast.error('Please enter a valid amount (greater than 0) for all cheques.');
        return;
      }

      // Validate IFSC code format if provided
      if (cheque.ifsc_code && !validateIFSC(cheque.ifsc_code)) {
        toast.error('Invalid IFSC code format. It should be 11 characters (e.g., SBIN0001234).');
        return;
      }
    }

    // Prepare payload
    const payload = {
      apply_as_payment: applyAsPayment,
      cheques: cheques.map((cheque) => ({
        amount: sanitizeToNumber(cheque.amount),
        date: formatISO(new Date(cheque.date)),
        project_id: invoiceData?.data?.[0]?.closedDeal?.unit?.project?.id,
        deal_id: invoiceData?.data?.[0]?.closedDeal?.id,
        cheque_number: cheque.cheque_number,
        account_holder_name: cheque.account_holder_name,
        ...(cheque.bank_name && { bank_name: cheque.bank_name }),
        ...(cheque.ifsc_code && { ifsc_code: cheque.ifsc_code.toUpperCase() })
      }))
    };

    onSubmit(payload);
    resetChequeModal();
  };

  return (
    <Modal
      isDirty={true}
      confirmOnClose={true}
      width={60}
      onClose={resetChequeModal}
      name={'Add Cheque'}>
      <div>
        <div className="flex justify-center flex-col mb-8">
          <form onSubmit={handleFormSubmit} className="flex flex-col gap-4 pt-6">
            {/* Multiple Cheques List */}
            {cheques.map((cheque, idx) => (
              <div
                key={idx}
                className="relative flex flex-col gap-4 w-full border border-gray-200 rounded-lg p-4 pt-6">
                {/* Remove Icon - Top Right */}
                {cheques.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveChequeRow(idx)}
                    disabled={isSubmitting}
                    className={`absolute top-2 right-2 p-1 rounded-full transition-colors duration-200 ${
                      isSubmitting
                        ? 'cursor-not-allowed opacity-50 text-gray-300'
                        : 'hover:bg-gray-100 text-gray-500 hover:text-red-500'
                    }`}>
                    <RiCloseLine size={20} />
                  </button>
                )}

                {/* Row 1: Amount, Date, Cheque Number */}
                <div className="flex gap-4 items-end w-full">
                  <FormInput
                    width={32}
                    label={'Amount'}
                    isRequired
                    register_key={`chequeAmount_${idx}`}
                    type={'number'}
                    valuePre={cheque.amount}
                    onType={(val) =>
                      handleChequeChange(idx, 'amount', val.target ? val.target.value : val)
                    }
                    register={dummyRegister}
                  />
                  <FormInput
                    width={32}
                    label={'Date'}
                    isRequired
                    register_key={`chequeDate_${idx}`}
                    type={'date'}
                    valuePre={cheque.date}
                    onType={(val) =>
                      handleChequeChange(idx, 'date', val.target ? val.target.value : val)
                    }
                    register={dummyRegister}
                  />
                  <FormInput
                    width={32}
                    label={'Cheque Number'}
                    isRequired
                    register_key={`chequeNumber_${idx}`}
                    type={'text'}
                    valuePre={cheque.cheque_number}
                    onType={(val) =>
                      handleChequeChange(idx, 'cheque_number', val.target ? val.target.value : val)
                    }
                    register={dummyRegister}
                  />
                </div>

                {/* Row 2: Account Holder Name, Bank Name, IFSC Code */}
                <div className="flex gap-4 items-end w-full">
                  <FormInput
                    width={32}
                    label={'Account Holder Name'}
                    isRequired
                    register_key={`accountHolder_${idx}`}
                    type={'text'}
                    valuePre={cheque.account_holder_name}
                    onType={(val) =>
                      handleChequeChange(
                        idx,
                        'account_holder_name',
                        val.target ? val.target.value : val
                      )
                    }
                    register={dummyRegister}
                  />
                  <FormInput
                    width={32}
                    label={'Bank Name'}
                    register_key={`bankName_${idx}`}
                    type={'dropdown'}
                    options={[
                      { id: '', value: '', label: 'Select Bank', disabled: true, selected: true },
                      ...INDIAN_BANKS
                    ]}
                    valuePre={cheque.bank_name}
                    onDropdownChange={(val) => handleChequeChange(idx, 'bank_name', val)}
                    register={dummyRegister}
                    isRequired
                  />
                  <FormInput
                    width={32}
                    label={'IFSC Code'}
                    register_key={`ifscCode_${idx}`}
                    type={'text'}
                    placeholder={'e.g., SBIN0001234'}
                    valuePre={cheque.ifsc_code}
                    onType={(val) => {
                      const value = val.target ? val.target.value : val;
                      handleChequeChange(idx, 'ifsc_code', value.toUpperCase());
                    }}
                    register={dummyRegister}
                    CustomFeature={{
                      maxLength: 11,
                      style: { textTransform: 'uppercase' }
                    }}
                  />
                </div>
              </div>
            ))}
            <div>
              <Button
                type="button"
                onClick={handleAddChequeRow}
                displayType="secondary"
                disabled={isSubmitting}>
                + Add Cheque
              </Button>
            </div>
            <label className="flex items-start gap-2 text-sm text-gray-700 cursor-pointer select-none">
              <input
                type="checkbox"
                className="mt-1"
                checked={applyAsPayment}
                disabled={isSubmitting}
                onChange={(e) => setApplyAsPayment(e.target.checked)}
              />
              <span>
                <span className="font-medium text-gray-900">Apply as payment to invoices</span>
                <span className="block text-gray-500">
                  Allocates cheque amount to unpaid invoices (oldest first) and updates Paid Amount.
                  Turn off only if you want to store the cheque without recording payment.
                </span>
              </span>
            </label>
            <div className="w-full flex justify-end items-center space-x-4 mt-8">
              <Button
                type="button"
                onClick={resetChequeModal}
                displayType="secondary"
                disabled={isSubmitting}>
                Cancel
              </Button>
              <Button type="submit" disabled={isSubmitting}>
                {isSubmitting
                  ? 'Creating...'
                  : applyAsPayment
                    ? 'Create & Apply Payment'
                    : 'Create Cheques'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default AddChequeForm;
